import { connect } from 'react-redux';
import { isNil, get } from 'lodash';
import Valuation, {
  ValuationProps,
} from '@/components/DeprecatedPortfolio/components/Valuation';
import { portfolioSelector } from '@/components/DeprecatedPortfolio/redux/selectors';
import {
  getMarketAveragePBSelector,
  getMarketAveragePEGSelector,
  getMarketAveragePESelector,
  getMarketAverageROASelector,
  getMarketAverageROESelector,
  getMarketAverageCountryNameSelector,
} from '@industyAverages/redux/selectors';
import { areStatesEqualCompanySection } from '@/pages/CompanyReport/redux/selectors';

type StateProps = Omit<ValuationProps, 'sectionNumber'>;
const mapStateToProps = (state): StateProps => {
  const portfolio = portfolioSelector(state);

  const industyAveragesProps = {
    industryId: 0,
    marketISO2: get(portfolio, ['marketISO2'], ''),
  };

  const marketAveragePB = getMarketAveragePBSelector(
    state,
    industyAveragesProps
  );

  const marketAveragePE = getMarketAveragePESelector(
    state,
    industyAveragesProps
  );

  const marketAveragePEG = getMarketAveragePEGSelector(
    state,
    industyAveragesProps
  );

  const marketAverageROA = getMarketAverageROASelector(
    state,
    industyAveragesProps
  );

  const marketAverageROE = getMarketAverageROESelector(
    state,
    industyAveragesProps
  );

  const marketName = getMarketAverageCountryNameSelector(
    state,
    industyAveragesProps
  );

  return {
    portfolioId: get(portfolio || {}, ['id'], ''),
    marketName,
    PB: portfolio && portfolio.PB,
    marketPB: !isNil(marketAveragePB) ? marketAveragePB.value : undefined,
    PEG: portfolio && portfolio.PEG,
    marketPEG: !isNil(marketAveragePEG) ? marketAveragePEG.value : undefined,
    PE: portfolio && portfolio.PE,
    marketPE: !isNil(marketAveragePE) ? marketAveragePE.value : undefined,
    ROA: portfolio && portfolio.ROA,
    marketROA: !isNil(marketAverageROA)
      ? marketAverageROA.value * 100
      : undefined,
    ROE: portfolio && portfolio.ROE,
    marketROE: !isNil(marketAverageROE)
      ? marketAverageROE.value * 100
      : undefined,
    currencyISO: get(portfolio || {}, ['currencyISO'], ''),
    portfolioName: get(portfolio || {}, ['name'], ''),
    secretCode: get(portfolio || {}, ['secretCode'], undefined),
    totalFreeCashFlowValue: get(
      portfolio || {},
      ['totalFreeCashFlowValue'],
      NaN
    ),
    totalFreeCashFlowValueFormatted: get(
      portfolio || {},
      ['totalFreeCashFlowValueFormatted'],
      ''
    ),
    totalFreeCashFlowDiscount: get(
      portfolio || {},
      ['totalFreeCashFlowDiscount'],
      NaN
    ),
    totalFreeCashFlowDiscountFormatted: get(
      portfolio || {},
      ['totalFreeCashFlowDiscountFormatted'],
      ''
    ),
    intrinsicDiscount: get(portfolio || {}, ['intrinsicDiscount'], NaN),
    intrinsicDiscountFormatted: get(
      portfolio || {},
      ['intrinsicDiscountFormatted'],
      ''
    ),
  };
};

export default connect(mapStateToProps, null, null, {
  areStatesEqual: areStatesEqualCompanySection,
})(Valuation);
